"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableHeaderData = void 0;
var tslib_1 = require("tslib");
var helpers_1 = require("Views/Partials/Components/TableCore/helpers");
var components_1 = require("../components");
var shouldHaveTypeColumn = function (rows) {
    var rowsWithType = rows.filter(function (row) { return row.type && row.type.length !== 0; });
    return rowsWithType.length > 0;
};
var shouldHaveDurationColumn = function (rows) {
    var rowsWithDuration = rows.filter(function (row) { return row.duration && row.duration.length !== 0; });
    return rowsWithDuration.length > 0;
};
var getTableHeaderData = function (rows, dictionary) {
    return components_1.learningComponentHeaderConfig
        .map(function (headerCell) {
        if (rows && rows.length !== 0) {
            if (headerCell.name === components_1.LearningComponentHeaderCellEnum.Type && !shouldHaveTypeColumn(rows))
                return;
            if (headerCell.name === components_1.LearningComponentHeaderCellEnum.Duration &&
                !shouldHaveDurationColumn(rows))
                return;
        }
        return tslib_1.__assign(tslib_1.__assign({}, headerCell), { label: helpers_1.getValueFromDictionary(dictionary, headerCell.label) });
    })
        .filter(function (column) { return column; });
};
exports.getTableHeaderData = getTableHeaderData;
